import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getCostCenterList as getCostCenterListApi,
	getCostCenterQuery as getCostCenterQueryApi,
	getCostCenter as getCostCenterApi,
	addNewCostCenter as addNewCostCenterApi,
	updateCostCenter as updateCostCenterApi,
	deleteCostCenter as deleteCostCenterApi,
	importCostCenter as importCostCenterApi,
} from '../../helpers/establishment/backend_helper';

export const getCostCenterList = createAsyncThunk('costCenter/getCostCenterList', async () => {
	try {
		const response = getCostCenterListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getCostCenterQuery = createAsyncThunk('costCenter/getCostCenterQuery', async params => {
	try {
		const response = await getCostCenterQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getCostCenter = createAsyncThunk('costCenter/getCostCenter', async cost_center_id => {
	try {
		const response = getCostCenterApi(cost_center_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewCostCenter = createAsyncThunk('costCenter/addNewCostCenter', async cost_center => {
	try {
		const response = addNewCostCenterApi(cost_center);
		toast.success('Centro de Costo agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar cost_center.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateCostCenter = createAsyncThunk('costCenter/updateCostCenter', async (cost_center) => {
		try {
			const response = updateCostCenterApi(cost_center);
			toast.success('Centro de Costo actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar cost_center.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteCostCenter = createAsyncThunk('costCenter/deleteCostCenter', async cost_center => {
	try {
		const response = await deleteCostCenterApi(cost_center);
		toast.success('Centro de Costo eliminado exitosamente.', { autoClose: 3000 });
		return { cost_center, ...response };
	} catch (error) {
		toast.error('Error al eliminar cost_center.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const importCostCenter = createAsyncThunk('costCenter/importCostCenter', async (data) => {
	try {
		toast.info('Preparando la carga de Centros de Costo', { autoClose: 3000 });

		const response = await importCostCenterApi(data);
		console.log('response', response)
		
		if (response?.message === 'Import completed successfully') {
			toast.success('Centros de Costo cargados exitosamente', { autoClose: 3000 });
		} else {
			toast.error('Error en la carga de Centros de Costo', { autoClose: 3000 });
		}

		return response;
	} catch (error) {
		toast.error('Error en la carga de Centros de Costo', { autoClose: 3000 });
		throw new Error(error);
	}
});

